import {
  BookmarkResponse,
  ComputeAnalysisByIdResponse,
  ComputeAnalysisResponse,
  ComputeApplicationsResponse,
  ComputeAppSession,
  LaunchAnalysisResponse,
} from '../../interfaces';
import { forkJoin, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { CommonApiService } from 'polly-commons';
import { ApiEndPoints } from '../../../polly-manage.constants';

@Injectable({
  providedIn: 'root',
})
export class PollyManageAnalysisService {
  constructor(private readonly commonApiService: CommonApiService) {}

  public getAnalysisUrl(runId: number, analysisUrlType?: string): string {
    const url: string = `compute/analysis/${runId}`;
    return analysisUrlType ? `${url}/${analysisUrlType}` : url;
  }

  public getBookmarks(workspaceId: string, analysisId: number): Observable<BookmarkResponse> {
    return this.commonApiService.get(`/compute/${workspaceId}/analysis/${analysisId}/bookmarks`);
  }

  public getBookmarkRestoreApplicationUrl(workspaceId: string, analysisId: number, bookmarkId: string): Observable<LaunchAnalysisResponse> {
    return this.commonApiService.get(`/compute/${workspaceId}/analysis/${analysisId}?action=restore&bookmark=${bookmarkId}`);
  }

  public getApplicationDetailsById(workspaceId: string, analysisId: number): Observable<ComputeAnalysisResponse> {
    return this.commonApiService.get(`/compute/${workspaceId}/analysis/${analysisId}`);
  }

  public getApplicationLaunchUrl(workspaceId: string, analysisId: number): Observable<LaunchAnalysisResponse> {
    return this.commonApiService.get(`/compute/${workspaceId}/analysis/${analysisId}?action=launch`);
  }

  public deleteRunningAppliationSession(
    workspaceId: string,
    analysisId: number | string,
    sessionId: string
  ): Observable<ComputeAppSession> {
    const routeUri = `/compute/${workspaceId}/analysis/${analysisId}?session=${sessionId}`;
    return this.commonApiService.delete(routeUri);
  }

  public getVersionDetails(workspaceId: string, analysisId: number | string): Observable<BookmarkResponse> {
    const url = `/compute/${workspaceId}/analysis/${analysisId}/bookmarks`;
    return this.commonApiService.get(url);
  }

  public fetchAppAndAnalysisDetails(
    appId: string,
    workspaceId: string,
    analysisId: string
  ): Observable<{
    appResponse: ComputeApplicationsResponse;
    analysisResponse: ComputeAnalysisByIdResponse;
  }> {
    return forkJoin({
      appResponse: this.commonApiService.get(`/compute/app/${appId}`),
      analysisResponse: this.commonApiService.get(`/compute/${workspaceId}/analysis/${analysisId}`),
    });
  }

  private buildTerminateUrl(analysisRunId: number, workspaceId: string): string {
    return `${this.getAnalysisUrl(analysisRunId)}/${ApiEndPoints.GET_COMPUTE_APP_SESSION}?${ApiEndPoints.ACTION}${
      ApiEndPoints.TERMINATE
    }&workspace_id=${workspaceId}`;
  }

  public terminateAnalysisSession(analysisRunId: number, workspaceId: string): Observable<ComputeAppSession> {
    const url = this.buildTerminateUrl(analysisRunId, workspaceId);
    return this.commonApiService.delete(url);
  }
}
